import { render, staticRenderFns } from "./GroupBuyRefundPane.vue?vue&type=template&id=28c48e29&scoped=true"
import script from "./GroupBuyRefundPane.vue?vue&type=script&lang=js"
export * from "./GroupBuyRefundPane.vue?vue&type=script&lang=js"
import style0 from "./GroupBuyRefundPane.vue?vue&type=style&index=0&id=28c48e29&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28c48e29",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/mall_vue_JOYE/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('28c48e29')) {
      api.createRecord('28c48e29', component.options)
    } else {
      api.reload('28c48e29', component.options)
    }
    module.hot.accept("./GroupBuyRefundPane.vue?vue&type=template&id=28c48e29&scoped=true", function () {
      api.rerender('28c48e29', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/activity/groupBuy/GroupBuyRefundPane.vue"
export default component.exports